export const paginator = {
  root: {
    padding: "{padding.16}",
    gap: "{gap.4}",
    borderRadius: "0",
    background: "{content.background}",
    color: "{text.caption}",
    transitionDuration: "{transition.duration}",
  },
  navButton: {
    background: "transparent",
    // hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.support}",
    color: "{text.caption}",
    // hoverColor: "{text.hover.muted.color}",
    selectedColor: "{navigation.item.activeColor}",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  currentPageReport: {
    color: "{text.caption}",
  },
  // jumpToPageInput: {
  //   maxWidth: "2.5rem",
  // },
  css: (): string => `
    .p-paginator-first {
      order: -2;
    }

    .p-paginator-prev {
      order: -1;
    }
  `,
};
